import React from "react";
import themeColors from "../../data/colors"; // adjust path if needed

export default function AnimatedGradientBackground() {
  const stepDuration = 5;
  const totalDuration = themeColors.length * stepDuration;

  return (
    <div className="animated-gradient-stack" aria-hidden="true">
      {themeColors.map((color, index) => (
        <div
          key={`${color.title}-${index}`}
          className="animated-gradient-stack-layer"
          style={{
            background: `linear-gradient(90deg, rgba(${color.dark.rgb},1) 0%, rgba(${color.dark.rgb},0) 100%)`,
            animationDuration: `${totalDuration}s`,
            animationDelay: `${index * stepDuration}s`,
          }}
        />
      ))}
    </div>
  );
}
